var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.81 36.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.44,6.18H14.75a7.56,7.56,0,0,0-7.56,7.56V35.43A7.57,7.57,0,0,0,14.75,43H36.44A7.56,7.56,0,0,0,44,35.43V13.74A7.55,7.55,0,0,0,36.44,6.18ZM18.23,37.88H12.71V20.11h5.52Zm-2.76-20.2a3.2,3.2,0,1,1,3.2-3.2A3.2,3.2,0,0,1,15.47,17.68Zm23.45,20.2H33.4V29.24c0-2.06,0-4.71-2.87-4.71s-3.31,2.25-3.31,4.56v8.79H21.7V20.11H27v2.43h.07a5.8,5.8,0,0,1,5.23-2.87c5.59,0,6.62,3.68,6.62,8.47Z",
    transform: "translate(-7.19 -6.18)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.360d90ce47be259eb0b39f278d284f42.svg";
export { ForwardRef as ReactComponent };